import { jsx, css } from '@emotion/react';
import { connectLocation } from '../../location/LocationConnectors'
import Card from '../oc-card'
import RichText from "../oc-rich-text"
import Section from './oc-section';

const styles = css`
  .features {
    display: grid;
    grid-template-columns: 1fr;
    gap: 30px;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }

    & > div {
      margin-bottom: 0;
    }
  }
`

const ProductFeatures = connectLocation(({ t, features, intro, heading, anchor, className }) => (
  <Section anchor={anchor} css={styles} className={className}>
    <h2><RichText content={heading}/></h2>
    {intro ? <p><RichText content={intro}/></p> : null}
    <div className="features">
      {features.map(({ uid, images, proper_name, description = {}, title = {} }) => (
        <Card key={uid} img={images.banner?.url} alt={proper_name}>
          <h3 className="h4"><RichText content={title.value || proper_name}/></h3>
          {description.value ? <p><RichText content={description.value}/></p> : null}
        </Card>
      ))}
    </div>
  </Section>
))

ProductFeatures.WrappedComponent.displayName = 'ProductFeatures'

export default ProductFeatures
